const initialValue = {
  itemSelectablePos: [],
  itemSelectablePrices: [],
}

export default initialValue
